import { captureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useScaffold } from "@Light/scaffold";
import { useNavigate, useSearchParams } from "@Light/utils/context";
import clsx from "clsx";

export type UnsupportedBatteryProps = {
  onComplete?: (reason: string) => void;
};

export function UnsupportedBattery({ onComplete }: UnsupportedBatteryProps) {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const manufacturer = searchParams.get("manufacturer") || "this battery type";

  const handleNotifyMe = () => {
    captureEvent("unsupported_battery_notify_requested", {
      device_type: "battery",
      manufacturer,
    });
    if (onComplete) {
      onComplete("unsupported_battery_notify_requested");
    }
    // Don't automatically close the flow - user should use the close button
  };

  return (
    <PageBody
      centered
      title={`We're still working on supporting ${manufacturer} batteries`}
      footer={
        <ButtonFooter>
          <Button size="lg" className="w-full" onClick={handleNotifyMe}>
            Notify me when available
          </Button>
          <Button
            size="lg"
            buttonType="outline"
            className="w-full"
            onClick={() => {
              navigate("/devices/link-battery/manufacturer");
            }}
          >
            Go back
          </Button>
        </ButtonFooter>
      }
    >
      <p className={clsx("text-base", scaffold.page.colors.text.tertiary)}>
        Thanks for letting us know that there is demand for {manufacturer}{" "}
        batteries.
      </p>
    </PageBody>
  );
}
